import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { SelectFieldOption } from "@sdbn/common";
import { ActionType, RoutingPosition, RoutingPositionTask, StationLevel, StationType } from "../../routing-position.model";
import { StationAssignmentStrategy } from 'src/tmc-yard/common/station-assignment-strategy/station-assignment-strategy.model';
import { Task } from "src/tmc-yard/components/task-assignment/model/task";
import { TaskAssignmentService } from "src/tmc-yard/components/task-assignment/service/task-assignment.service";
import { StructureSelection } from "src/tmc-yard/common/structure-selection/structure-selection.model";
import { StructureSelectionService } from "src/tmc-yard/common/structure-selection/structure-selection-dialog/structure-selection-dialog-service";
import { TmcContextService } from "src/tmc-common/services/tmc-context.service";

@Component({
  selector: 'app-routing-position-editor',
  templateUrl: './routing-position-editor.component.html',
  styleUrls: ['./routing-position-editor.component.scss']
})
export class RoutingPositionEditorComponent implements OnInit {

  private routingPosition: RoutingPosition;

  @Input('routingPosition') set setRoutingPosition(routingPosition: RoutingPosition) {
    this.routingPosition = routingPosition;
    this.initForm(routingPosition);
  }

  @Input() set disabled(disabled: boolean) {
    if (disabled) {
      this.form.disable();
    } else {
      this.form.enable();
    }
  }

  @Output() changed = new EventEmitter<void>();

  availableActionTypes: Array<SelectFieldOption> = [];

  availableStationAssignmentStrategyOptions: Array<SelectFieldOption> = [];

  form = new FormGroup({
    stationName: new FormControl(),
    actionType: new FormControl(),
    cargo: new FormControl(),
    waitingForRetrieve: new FormControl(),
    predictedDuration: new FormControl(),
    stationAssignmentStrategy: new FormControl(),
    hint: new FormControl()
  });

  constructor(private taskAssignmentService: TaskAssignmentService,
    private structureSelectionService: StructureSelectionService,
    private tmcContextService: TmcContextService) {

  }

  ngOnInit(): void {

    for (const actionType of Object.keys(ActionType)) {
      this.availableActionTypes.push(new SelectFieldOption({
        labelDictionaryKey: 'tmc.transport.routing.routingPosition.actionType.' + actionType,
        value: actionType
      }));
    }

    for (const assignmentStrategy of Object.keys(StationAssignmentStrategy)) {
      this.availableStationAssignmentStrategyOptions.push(new SelectFieldOption({
        labelDictionaryKey: 'tmc.common.entity.station-assignment-strategy.' + assignmentStrategy,
        value: assignmentStrategy
      }));
    }
  }

  assignTasks() {
    const editTasks: Task[] = [];
    if (this.routingPosition.tasks) {
      for (const t of this.routingPosition.tasks) {
        const dTask = new Task({});
        dTask.id = t.id;
        dTask.relevance = t.relevance;
        dTask.processingStatus = t.processingStatus;
        editTasks.push(dTask);
      }
    }

    this.taskAssignmentService.openAssignmentDialog(editTasks, this.routingPosition.processingStatusModel).subscribe(next => {
      if (next != null) {
        this.routingPosition.tasks = [];
        for (const n of next) {
          this.routingPosition.tasks.push(new RoutingPositionTask({ id: n.id, relevance: n.relevance, processingStatus: n.processingStatus }));
        }
      }
    });
  }
  assignStation() {
    const structureSelection = new StructureSelection();

    if (this.routingPosition.stationLevel === StationLevel.STATION_GROUP) {
      structureSelection.stationGroupId = this.routingPosition.stationId;
    } else if (this.routingPosition.stationLevel === StationLevel.STATION_SET) {
      structureSelection.stationSetId = this.routingPosition.stationId;
    } else if (this.routingPosition.stationLevel === StationLevel.STATION) {
      structureSelection.stationId = this.routingPosition.stationId;
    }

    this.structureSelectionService.selectStationSetOrStation(structureSelection).subscribe(
      value => {

        const selection: StructureSelection = value;

        if (value != null) {
          if (selection.stationId != null) {
            this.routingPosition.stationLevel = StationLevel.STATION;
            this.routingPosition.stationId = selection.stationId;
            this.routingPosition.stationType = StationType.WORKING_AREA;
            const station = this.tmcContextService.findStationById(selection.stationId);
            this.routingPosition.stationName = station.name;
            if (station.stationType === StationType.WAITING_AREA) {
              this.routingPosition.stationType = StationType.WAITING_AREA;
              this.routingPosition.actionType = ActionType.NONE;
              this.routingPosition.waitingForRetrieve = false;
              this.routingPosition.cargo = '';
            }
          } else if (selection.stationSetId != null) {
            this.routingPosition.stationLevel = StationLevel.STATION_SET;
            this.routingPosition.stationId = selection.stationSetId;
            const stationSet = this.tmcContextService.findStationSetById(selection.stationSetId);
            this.routingPosition.stationName = stationSet.name;
            this.routingPosition.stationType = StationType.WORKING_AREA;
          } else if (selection.stationGroupId != null) {
            this.routingPosition.stationLevel = StationLevel.STATION_GROUP;
            this.routingPosition.stationId = selection.stationGroupId;
            this.routingPosition.stationName = this.tmcContextService.findStationGroupById(selection.stationGroupId).name;
            this.routingPosition.stationType = StationType.WORKING_AREA;
          }
        }
        this.form.controls.stationName.setValue(this.routingPosition.stationName);
      }, error => {
        console.error(error);
      });
  }

  private initForm(routingPosition: RoutingPosition) {
    this.form.patchValue({
      stationName: routingPosition.stationName,
      actionType: routingPosition.actionType,
      cargo: routingPosition.cargo,
      waitingForRetrieve: routingPosition.waitingForRetrieve,
      predictedDuration: routingPosition.predictedDuration,
      stationAssignmentStrategy: routingPosition.stationAssignmentStrategy,
      hint: routingPosition.hint
    });

    this.form.valueChanges.subscribe(values => {
      this.routingPosition.actionType = values.actionType,
        this.routingPosition.cargo = values.cargo,
        this.routingPosition.waitingForRetrieve = values.waitingForRetrieve,
        this.routingPosition.predictedDuration = values.predictedDuration,
        this.routingPosition.stationAssignmentStrategy = values.stationAssignmentStrategy,
        this.routingPosition.hint = values.hint
        this.changed.emit();
    });
  }
}
